import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";
import { insertUser } from "service/api";

const Register = props => {

  //meta title
  document.title = "Register | Ai in realstate";
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      username: '',
      password: '',
      phone: '',
      role: 'customer'
    },

    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
      username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().min(6, "Minimum 6 characters").required("Please Enter Your Password"),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
        .required("Please Enter Your Phone Number"),
      role: Yup.string().required("Please Select a Role"),
    }),

    onSubmit: async (values) => {
      try {
        const payload = {
          username: values.username,
          email: values.email,
          phone_no: values.phone,   // MAP FIELD
          password: values.password,
          user_type: values.role,  // MAP FIELD
        };

        const response = await insertUser(payload);

        if (response.data.success) {
          alert("User Registered Successfully!");
          validation.resetForm();

          navigate("/login");
        } else {
          alert(response.data.message || "Registration failed");
        }
      } catch (error) {
        alert(
          error.response?.data?.message ||
          "Server error. Please try again later."
        );
      }
    }

  });

  const { user, registrationError, loading } = useSelector(state => ({
    user: state.Account.user,
    registrationError: state.Account.registrationError,
    loading: state.Account.loading,
  }));

  useEffect(() => {
    dispatch(apiError(""));
  }, []);

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-light">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card
                className="overflow-hidden"
                style={{
                  background: "rgba(255, 255, 255, 0.1)", // Semi-transparent white background
                  border: "1px solid rgba(255, 255, 255, 0.2)", // Light border for definition
                  borderRadius: "16px", // Rounded corners for a modern look
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)", // Subtle shadow for elevation
                  backdropFilter: "blur(10px)", // Blurred background for depth
                  padding: "16px", // Padding for internal spacing
                  color: "#ffffff", // White text color for readability
                }}
              >
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-white">Free Register</h5>
                        <p className="text-white">Get your free Aiinrealestate account now.</p>
                      </div>
                    </Col>
                    <Col xs={5} className="align-self-end text-center">
                      <img
                        src={profileImg}
                        alt=""
                        className="img-fluid"
                        style={{ maxWidth: "80%", borderRadius: "50%" }} // Reduced size and circular image
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-1">
                  <div>
                    <Link to="/">
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {user && user ? (
                        <Alert color="success">Register User Successfully</Alert>
                      ) : null}

                      {registrationError ? (
                        <Alert color="danger">{registrationError}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label" style={{ color: "#ffffff" }}>
                          Email
                        </Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        />
                        {validation.touched.email && validation.errors.email && (
                          <FormFeedback
                            type="invalid"
                            style={{
                              display: "block",
                              color: "#ff4d4f",
                              fontWeight: "600",
                              marginTop: "4px",
                              textShadow: "0 0 2px rgba(0,0,0,0.6)"
                            }}
                          >
                            {validation.errors.email}
                          </FormFeedback>
                        )}

                      </div>

                      <div className="mb-3">
                        <Label className="form-label" style={{ color: "#ffffff" }}>
                          Username
                        </Label>
                        <Input
                          name="username"
                          type="text"
                          placeholder="Enter username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        />
                        {validation.touched.username && validation.errors.username && (
                          <FormFeedback type="invalid"
                            style={{
                              display: "block",
                              color: "#ff4d4f",
                              fontWeight: "600",
                              marginTop: "4px",
                              textShadow: "0 0 2px rgba(0,0,0,0.6)"
                            }}
                          >
                            {validation.errors.username}
                          </FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label" style={{ color: "#ffffff" }}>
                          Phone Number
                        </Label>

                        <Input
                          name="phone"
                          type="text"
                          maxLength={11}
                          placeholder="Enter phone number"
                          value={validation.values.phone || ""}

                          onChange={(e) => {
                            const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                            validation.setFieldValue("phone", onlyNumbers);
                          }}

                          onBlur={validation.handleBlur}

                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        />

                        {validation.touched.phone && validation.errors.phone && (
                          <FormFeedback type="invalid"
                            style={{
                              display: "block",
                              color: "#ff4d4f",
                              fontWeight: "600",
                              marginTop: "4px",
                              textShadow: "0 0 2px rgba(0,0,0,0.6)"
                            }}
                          >
                            {validation.errors.phone}
                          </FormFeedback>
                        )}
                      </div>


                      <div className="mb-3">
                        <Label className="form-label" style={{ color: "#ffffff" }}>
                          Role
                        </Label>

                        <Input
                          type="select"
                          name="role"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.role}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(5px)",
                          }}
                        >
                          <option
                            value="customer"
                            style={{ background: "rgba(0, 0, 0, 0.9)", color: "#ffffff" }}
                          >
                            Customer
                          </option>
                          <option
                            value="builder"
                            style={{ background: "rgba(0, 0, 0, 0.9)", color: "#ffffff" }}
                          >
                            Builder
                          </option>
                          <option
                            value="other"
                            style={{ background: "rgba(0, 0, 0, 0.9)", color: "#ffffff" }}
                          >
                            Other
                          </option>
                        </Input>

                        {validation.touched.role && validation.errors.role && (
                          <FormFeedback type="invalid"
                            style={{
                              display: "block",
                              color: "#ff4d4f",
                              fontWeight: "600",
                              marginTop: "4px",
                              textShadow: "0 0 2px rgba(0,0,0,0.6)"
                            }}
                          >
                            {validation.errors.role}
                          </FormFeedback>
                        )}
                      </div>


                      <div className="mb-3">
                        <Label className="form-label" style={{ color: "#ffffff" }}>
                          Password
                        </Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        />
                        {validation.touched.password && validation.errors.password && (
                          <FormFeedback type="invalid"
                            style={{
                              display: "block",
                              color: "#ff4d4f",
                              fontWeight: "600",
                              marginTop: "4px",
                              textShadow: "0 0 2px rgba(0,0,0,0.6)"
                            }}
                          >
                            {validation.errors.password}
                          </FormFeedback>
                        )}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          style={{
                            backgroundColor: "#6f42c1",
                            border: "none",
                            fontSize: "16px",
                            borderRadius: "8px",
                            transition: "background-color 0.3s ease",
                          }}
                          onMouseOver={(e) => (e.target.style.backgroundColor = "#5a35a5")}
                          onMouseOut={(e) => (e.target.style.backgroundColor = "#6f42c1")}
                        >
                          Register
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Aiinrealestate. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Vivek
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;
